import script from "./SharebetReciept.vue?vue&type=script&setup=true&lang=js"
export * from "./SharebetReciept.vue?vue&type=script&setup=true&lang=js"

import "./SharebetReciept.vue?vue&type=style&index=0&id=7ab12a12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab12a12"]])

export default __exports__